import { render, staticRenderFns } from "./proLayout.vue?vue&type=template&id=31d14f73&scoped=true&"
import script from "./proLayout.vue?vue&type=script&lang=ts&"
export * from "./proLayout.vue?vue&type=script&lang=ts&"
import style0 from "./proLayout.vue?vue&type=style&index=0&id=31d14f73&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d14f73",
  null
  
)

export default component.exports